import { pagesToExclude } from "@store/constants";
import { useCurrentPage } from "@store/Framework/Store/Store/Components/RenderIfNeeded/Hooks/useCurrentPage";
import React, { ReactNode } from "react";

interface Props {
    Component: ReactNode;
}

const RenderIfNeeded = ({ Component }: Props) => {
    const { type } = useCurrentPage();
    const currentPageIsUnallowed = pagesToExclude.some(page => page === type);

    if (currentPageIsUnallowed) {
        return null;
    }

    return <>{Component}</>;
};

export default RenderIfNeeded;
